
import React from 'react';

export interface LogoProps {
  className?: string;
}

export function Logo({ className = "" }: LogoProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <span className="text-xl font-bold">
        <span className="text-primary">Trotting</span>
        <span className="text-muted-foreground"> the </span>
        <span className="text-foreground">World</span>
      </span>
    </div>
  );
}
